import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HeroSearchForm from './HeroSearchForm';

export default function HeroSection() {

    return (
        <>
            <section className='hero-section hero-section-one' id='home'>
                <Container>
                    <Row>
                        <Col md={12}>
                            <div className="hero-section-main-content">
                                <div className="hero-section-content text-center w-100 position-relative">
                                    <Row className='justify-content-center'>
                                        <Col lg={10} xl={7} xxl={8}>
                                            <span className='hero-badge shadow-sm mb-3'>A Vision for Your Life</span>
                                            <h1 className='hero-title display-2 fw-bold mb-0'>Find Your Best <span className='text-primary d-inline-block'>Real Estate</span></h1>
                                            <p className='fw-medium fs-18 text-dark mt-4 mx-lg-3 mx-xl-5 pt-1 mb-50'>Explore luxury properties suited to your preferences, ranging from beautiful homes to rewarding investments. Start your adventure with us and unlock the door to your dream property.</p>
                                        </Col>
                                    </Row>
                                    <Row className='justify-content-center'>
                                        <Col xl={10}>
                                            <ul className="nav nav-tabs justify-content-center hero-tab-filter" id="myTab" role="tablist">
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link active" id="buy-tab" data-bs-toggle="tab" data-bs-target="#buy-tab-pane"
                                                        type="button" role="tab" aria-controls="buy-tab-pane" aria-selected="true">Buy</button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link" id="sell-tab" data-bs-toggle="tab" data-bs-target="#sell-tab-pane"
                                                        type="button" role="tab" aria-controls="sell-tab-pane" aria-selected="false">Sell</button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link" id="rent-tab" data-bs-toggle="tab" data-bs-target="#rent-tab-pane"
                                                        type="button" role="tab" aria-controls="rent-tab-pane" aria-selected="false">Rent</button>
                                                </li>
                                            </ul>
                                            <div className="tab-content hero-tab-content" id="myTabContent">
                                                <div className="tab-pane fade show active" id="buy-tab-pane" role="tabpanel" aria-labelledby="buy-tab" tabIndex="0">
                                                    <HeroSearchForm />
                                                </div>
                                                <div className="tab-pane fade" id="sell-tab-pane" role="tabpanel" aria-labelledby="sell-tab" tabIndex="0">
                                                    <HeroSearchForm />
                                                </div>
                                                <div className="tab-pane fade" id="rent-tab-pane" role="tabpanel" aria-labelledby="rent-tab" tabIndex="0">
                                                    <HeroSearchForm />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}
